export enum StorageKey {
  AccessToken = 'JWT_TOKEN',
  AccessTokenExpire = 'JWT_TOKEN_EXPIRE',
  RefreshToken = 'REFRESH_TOKEN',
  CurrentUser = 'CURRENT_USER',
  CourseFilter = 'COURSE_FILTER',
  SelectedCompany = 'SELECTED_COMPANY',
  IsImpersonating = 'IS_IMPERSONATING',
  DebugMode = 'FRONTEND_DEBUG_MODE'
}
